<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_viii">Illustrations</a></p><a id="page_viii">
<p class="illt"><b>Maps</b></p>
</a><p class="noindent"><a id="page_viii"></a><span href="#/xhtml/21_Chapter07#map1" title="Link target outside of Sample">1. Areas of Strategic Responsibility in the Atlantic under ABC-1</span></p>
<p class="noindent"><span href="#/xhtml/21_Chapter07#map2" title="Link target outside of Sample">2. Areas of Strategic Responsibility in the Pacific and Far East under ABC-1</span></p>
<p class="noindent"><span href="#/xhtml/26_Conclusion#map3" title="Link target outside of Sample">3. Areas of Strategic Responsibility, 1 December 1941</span></p>
<p class="illt"><b>Figures</b></p>
<p class="noindent"><span href="#/xhtml/21_Chapter07#fig1" title="Link target outside of Sample">1. U.S. Military Mission under ABC-1</span></p>
<p class="noindent"><span href="#/xhtml/21_Chapter07#fig2" title="Link target outside of Sample">2. British Military Mission under ABC-1</span></p>
<p class="noindent"><span href="#/xhtml/22_Chapter08#fig3" title="Link target outside of Sample">3. U.S. Special Observer Group, London, May 1941</span></p>
<p class="noindent"><span href="#/xhtml/22_Chapter08#fig4" title="Link target outside of Sample">4. British Joint Staff Mission, Washington, D.C., May 1941</span></p>
<p class="noindent"><span href="#/xhtml/22_Chapter08#fig5" title="Link target outside of Sample">5. British Army Staff, British Joint Staff Mission, May 1941</span></p>
<p class="noindent"><span href="#/xhtml/22_Chapter08#fig6" title="Link target outside of Sample">6. British Admiralty Delegation, British Joint Staff Mission, June 1941</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_ListofIll.vue?5a857a36